import React from "react";
import "./OperationalAlert.css";

export default function OperationalAlert({ alerts }) {
  if (!alerts?.length) return null;
  return (
    <section className="fe2-alerts" aria-label="מידע חשוב">
      <h2 className="fe2-alerts__title">מידע חשוב</h2>
      <ul className="fe2-alerts__list">
        {alerts.map((alert) => (
          <li
            key={alert.title}
            className={`fe2-alerts__item fe2-alerts__item--${alert.tone || "info"}`}
          >
            <strong>{alert.title}</strong>
            {alert.body ? <p>{alert.body}</p> : null}
          </li>
        ))}
      </ul>
    </section>
  );
}
